import { MultiOptionARIAProps } from "../components";
import { useNavigationSiteCore } from "./useNavigationSiteCore";

export const useMultiSelectARIALabels = (): MultiOptionARIAProps => {
  const { commonARIALabel } = useNavigationSiteCore();

  const defaultARIALabel = {
    requiredARIALabel: "Required",
    searchARIALabel: "Search",
    closePopoverARIALabel: "Close Popover",
    showMoreARIALabel: "Show More",
    removeChipNameARIALabel: "Remove Chip Name",
    checkedStateARIALabel: "Checked",
    unCheckedStateARIALabel: "Unchecked",
  };

  return {
    requiredARIALabel:
      commonARIALabel.required ?? defaultARIALabel.requiredARIALabel,
    searchARIALabel: commonARIALabel.search ?? defaultARIALabel.searchARIALabel,
    showMoreARIALabel:
      commonARIALabel.showMoreDetails ?? defaultARIALabel.showMoreARIALabel,
    removeChipNameARIALabel:
      commonARIALabel.removeChipName ??
      defaultARIALabel.removeChipNameARIALabel,
    closePopoverARIALabel:
      commonARIALabel.closePopover ?? defaultARIALabel.closePopoverARIALabel,
    checkedStateARIALabel:
      commonARIALabel.checked ?? defaultARIALabel.checkedStateARIALabel,
    unCheckedStateARIALabel:
      commonARIALabel.unchecked ?? defaultARIALabel.unCheckedStateARIALabel,
  };
};
